import { DatePicker } from "$components/inputs";
import { Card, styled } from "@material-ui/core";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { useDebouncedCallback } from "use-debounce";
import InvoiceStatusFilter from "./InvoiceStatusFilter";
import type { InvoiceFilterStatus } from "./types";

const Container = styled(Card)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(1),
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  "& > *": {
    flex: 1,
    minWidth: "200px",
  },
}));

export const InvoiceFilters = ({
  fromDate,
  toDate,
  invoiceStatus,
  setFromDate,
  setToDate,
  setInvoiceStatus,
}: {
  fromDate?: string;
  toDate?: string;
  invoiceStatus?: InvoiceFilterStatus;
  setFromDate: (value: string) => void;
  setToDate: (value: string) => void;
  setInvoiceStatus: (value: InvoiceFilterStatus) => void;
}) => {
  const { formatMessage } = useIntl();
  const setFromDebounced = useDebouncedCallback(
    (date) => setFromDate(dayjs(date).format("YYYY-MM-DD")),
    800,
  );
  const setToDebounced = useDebouncedCallback(
    (date) => setToDate(dayjs(date).format("YYYY-MM-DD")),
    800,
  );

  return (
    <Container>
      <InvoiceStatusFilter
        setInvoiceStatus={setInvoiceStatus}
        invoiceStatus={invoiceStatus}
      />
      <DatePicker
        hideHelper
        label={formatMessage({
          id: "invoices.filter.from",
          defaultMessage: "From",
        })}
        inputProps={{ "aria-label": "Change From Date" }}
        onChange={setFromDebounced}
        value={fromDate ?? null}
      />
      <DatePicker
        hideHelper
        label={formatMessage({
          id: "invoices.filter.to",
          defaultMessage: "To",
        })}
        inputProps={{ "aria-label": "Change To Date" }}
        onChange={setToDebounced}
        value={toDate ?? null}
      />
    </Container>
  );
};
